import { SVGPropsIcon } from 'src/types';

export const LogInIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}>
      <g clipPath="url(#clip0_19534_17053)">
        <path
          d="M21.822 0.0150146C21.7971 0.0130005 21.776 0 21.75 0H11.0001C9.34607 0 8.00006 1.34601 8.00006 3V3.99994C8.00006 4.552 8.44794 5.00006 9 5.00006C9.55206 5.00006 9.99994 4.552 9.99994 3.99994V3C9.99994 2.44904 10.4489 2.00006 11.0001 2.00006H15.659L15.3539 2.10205C14.5441 2.38202 14.0001 3.14502 14.0001 3.99994V18.9999H11.0001C10.4489 18.9999 9.99994 18.551 9.99994 18V15.9999C9.99994 15.4481 9.55206 15 9 15C8.44794 15 8.00006 15.4481 8.00006 15.9999V18C8.00006 19.654 9.34607 21 11.0001 21H14.0001V21.9999C14.0001 23.103 14.8969 24 15.9999 24C16.214 24 16.4171 23.9691 16.637 23.9009L22.645 21.8979C23.456 21.618 24 20.855 24 20.0001V2.00006C24 0.834045 22.9949 -0.0800171 21.822 0.0150146Z"
          fill="currentColor"
        />
        <path
          d="M10.7069 9.29297L6.70697 5.29303C6.42096 5.00702 5.99103 4.92096 5.61694 5.07605C5.24396 5.23096 5.00006 5.59607 5.00006 6V9H0.999939C0.448059 9 0 9.44806 0 9.99994C0 10.552 0.448059 11.0001 0.999939 11.0001H5.00006V14.0001C5.00006 14.404 5.24396 14.7689 5.61694 14.924C5.99103 15.0789 6.42096 14.993 6.70697 14.707L10.7069 10.7069C11.098 10.316 11.098 9.68408 10.7069 9.29297Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19534_17053">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
